import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './retry.routes';
import MissingListService from '../../components/api/missing_list/missing_list.service';
import RetryService from '../../components/api/retry/retry.service';
import DateUtil from '../../components/logic/date_util/date_util.module';

export class RetryController {
    /*@ngInject*/
    constructor($mdDialog, $interval, $filter, MissingListService, RetryService, DateUtil) {
        this.RetryService = RetryService;
        this.MissingListService = MissingListService;
        this.DateUtil = DateUtil;
        this.$interval = $interval;
        this.$filter = $filter;

        this.targetDate = this.DateUtil.beginningOfDay(new Date());
        this.minDate = this.DateUtil.leapDate(this.targetDate, -99);
        this.maxDate = this.targetDate;
        this.maxPolling = 18;

        this.$mdDialog    = $mdDialog;
        this.error_dialog = $mdDialog.alert({
            clickOutSideToClose: true,
            title: 'エラーが発生しました',
            content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
            ok: 'OK'
        });
    }

    $onInit() {
        this.updateMissingList();
    }

    $onDestroy() {
        this.stopTimer();
    }

    updateMissingList() {
        this.MissingListService.index(
            this.DateUtil.getQueryParams(this.targetDate),
            response => {
                //this.missingList = response;
                // 制御用端末が欠損リストに出力されてしまうのを回避する一時的なコード
                // InsertInitialPower で制御用端末に定時データが挿入されなくなれば不要
                this.missingList = this.$filter("filter")(response, missingDevice => {
                  return !/^(tdc|dsc)[0-9]+/.test(missingDevice.pms_service_code);
                });
                this.missingDevices = this.countMissing(this.missingList);
                this.missingDeviceCount = Object.keys(this.missingDevices).length;

                if (this.missingDeviceCount === 0) {
                    this.stopTimer();
                }
            }
        );
    }

    // 戻り値
    // {
    //     dsw15406248: 23,
    //     dsw15406249: 2,
    //     dsw15406250: 14,
    //     dsw15406251: 5
    // }
    countMissing(missingList) {
        let deviceList = {};

        missingList.reduce((devices, currentMissingValue) => {
            let service_code = currentMissingValue.pms_service_code;
            devices[service_code] = devices[service_code] ? devices[service_code] + 1 : 1

            return devices;
        }, deviceList);

        return deviceList;
    }

    changeDate(diff) {
        this.stopTimer();

        if(diff !== undefined){
            this.targetDate = this.DateUtil.leapDate(this.targetDate, diff);
        }
        this.retried = false;
        this.retryFailed = false;

        this.updateMissingList();
    }

    retry() {
        this.retried = true;
        this.retryFailed = false;
        this.RetryService.create(
            {
                retry_list: this.missingList
            },
            response => {
                this.timer = this.$interval((count) => {
                    this.updateMissingList()
                    if(count >= this.maxPolling){
                        this.retryFailed = true;
                    }
                }, 10000, this.maxPolling);
            },
            error => {
                this.$mdDialog.show(this.error_dialog);
            }
        );
    }

    stopTimer() {
        if (this.timer) {
            this.$interval.cancel(this.timer);
        }
    }
}

export default angular.module('leptonApp.retry', [uiRouter, MissingListService, RetryService, DateUtil])
    .config(routing)
    .component('retry', {
        template: require('./retry.html'),
        controller: RetryController
    })
    .name;



// WEBPACK FOOTER //
// ./public/dev/app/retry/retry.component.js